import { Store } from "redux";

export const getGlobalStore = () => {
  return (window as any).reduxStore as Store;
};
